function newGroupDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/new-group/new-group-dialog.html?$$REVISION$$'
  }
}

export { newGroupDialogDirective }
